module.exports = __webpack_public_path__ + "static/assets/5a698caf57e6e92e8e875b3eb3121fdc.png";